import { render, staticRenderFns } from "./WelcomeBack.vue?vue&type=template&id=edfaf33e&scoped=true"
var script = {}
import style0 from "./WelcomeBack.vue?vue&type=style&index=0&id=edfaf33e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfaf33e",
  null
  
)

export default component.exports